// App-locale store — drives i18n for the authenticated app and auth
// pages (the marketing pages get their locale from the URL instead).
//
// Resolution: saved choice (localStorage "th-lang") > browser language
// > pt (the site's canonical locale). Persisted on change. Mirrors the
// theme store's shape.

import { create } from "zustand";

import { DEFAULT_LOCALE, isLocale, type Locale } from "@/i18n/config";

const STORAGE_KEY = "th-lang";

function initialLocale(): Locale {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && isLocale(saved)) return saved;
  } catch {
    /* storage blocked */
  }
  const nav = (navigator.language || "").slice(0, 2).toLowerCase();
  return isLocale(nav) ? nav : DEFAULT_LOCALE;
}

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useLocaleStore = create<LocaleState>((set) => ({
  locale: initialLocale(),
  setLocale: (locale) => {
    try {
      localStorage.setItem(STORAGE_KEY, locale);
    } catch {
      /* storage blocked — choice won't persist, still applies this session */
    }
    set({ locale });
  },
}));
